import { EOrderPaymentProviderType } from "../../Enum/EOrderPaymentProviderType"

export class EmployeeTapToPayDevice {
  employeeEntityId: string

  providerType: EOrderPaymentProviderType

  employeeName: string

  deviceId: string

  label?: string

  isActive: boolean

  constructor(data: Partial<EmployeeTapToPayDevice> = {}) {
    this.employeeEntityId = data.employeeEntityId ?? ""

    this.providerType = data.providerType ?? EOrderPaymentProviderType.None

    this.employeeName = data.employeeName ?? ""

    this.deviceId = data.deviceId ?? ""

    this.label = data.label

    this.isActive = data.isActive ?? false
  }
}
